import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { CSSTransition } from 'react-transition-group';
import { Portal } from '@codex/gadgets';
import { Icon } from '@codex/icons';

import Filter from './Filter';
import FilterPriceRange from './FilterPriceRange';
import MobileFilterList from './MobileFilterList';
import FiltersToggleButton from './presentionalComponents/FiltersToggleButton';
import MobileFilterItem from './presentionalComponents/MobileFilterItem';
import {
  getActiveListingPage,
  getNumberOfActiveFiltersOnActiveListingPage
} from '../../reduck/selectors';
import UISettings from '../../settings/UISettings';
import ConnectedLocationSearchBlock from '../TopLevelContainers/ConnectedLocationSearchBlock';

import { FilterContainer, FilterContainerLoader, FilterOverlay } from './styled';

class FiltersContainerTabletMobile extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      containerOpened: false,
      selectedFilter: null
    };

    this.animationDuration = 500;
  }

  renderFilterItem() {
    const { pendingProductsRequest } = this.props;

    if (this.state.selectedFilter === 'price') {
      return (
        <MobileFilterItem
          label={'Price'} // TODO: add to translations
          onFilterItemHeaderClick={() => {
            this.setState({ selectedFilter: null });
          }}
        >
          <FilterPriceRange
            loading={pendingProductsRequest}
            hideFilterItem={() => {
              this.setState({ selectedFilter: null });
            }}
          />
        </MobileFilterItem>
      );
    }

    const selectedFilterItem = this.props.filtersFromSearchLabs.find(
      (filter) => filter.id === this.state.selectedFilter
    );

    return (
      <MobileFilterItem
        label={
          selectedFilterItem.label === 'segment_id'
            ? 'Browse by category'
            : selectedFilterItem.label
        }
        onFilterItemHeaderClick={() => {
          this.setState({ selectedFilter: null });
        }}
      >
        <Filter
          loading={pendingProductsRequest}
          onlyOneFilterSelectedMode={selectedFilterItem.id === 'rounded_score'}
          filterItemData={selectedFilterItem}
          hideFilterItem={() => {
            this.setState({ selectedFilter: null });
          }}
        >
          {selectedFilterItem.id === 'delivery' ? (
            <ConnectedLocationSearchBlock name={'filter block'} />
          ) : null}
        </Filter>
      </MobileFilterItem>
    );
  }

  render() {
    const { props } = this;

    // The following code, which defined bypassPRODINC383 variable, is here in order to bypass https://ews-tactical.atlassian.net/browse/PRODINC-383
    // The PRODINC-383 is in SearchAPI and it has to be corrected by Findability team
    // TODO: remove this code as soon as PRODINC-383 is corrected
    const selectedFilterItem = props.filtersFromSearchLabs.find(
      (filter) => filter.id === this.state.selectedFilter
    );
    const bypassPRODINC383 =
      typeof selectedFilterItem === 'undefined' && this.state.selectedFilter === 'segment_id';

    return (
      <>
        <FiltersToggleButton
          activeFiltersCount={props.numberOfActiveFilters}
          onClick={(e) => {
            e.preventDefault();

            this.setState((state) => ({
              containerOpened: !state.containerOpened
            }));
          }}
        />
        <Portal domNode={document.body}>
          {this.state.containerOpened && this.props.pendingProductsRequest && (
            <FilterContainerLoader className={'dc-filter-container__loader'}>
              <Icon icon={'Spinner'} spin />
            </FilterContainerLoader>
          )}
          <CSSTransition
            classNames={'dc-filter-container'}
            timeout={this.animationDuration}
            in={this.state.containerOpened}
          >
            <FilterContainer
              className={'dc-filter-container'}
              data-is-loading={this.props.pendingProductsRequest}
              key={'filters-container'}
            >
              {
                // The bypassPRODINC383 variable is here to bypass https://ews-tactical.atlassian.net/browse/PRODINC-383
                // The PRODINC-383 is in SearchAPI and it has to be corrected by Findability team
                // TODO: remove bypassPRODINC383 from this code as soon as PRODINC-383 is corrected
              }
              {this.state.selectedFilter === null || bypassPRODINC383 ? (
                <MobileFilterList
                  loading={props.pendingProductsRequest}
                  filtersFromSearchLabs={props.filtersFromSearchLabs}
                  onDoneButtonClick={(e) => {
                    e.preventDefault();
                    if (this.state.containerOpened) {
                      this.setState((state) => ({
                        containerOpened: !state.containerOpened
                      }));
                    }
                    this.setState({ selectedFilter: null });
                  }}
                  onFilterListItemClick={(filterId) => {
                    this.setState({ selectedFilter: filterId });
                  }}
                />
              ) : (
                this.renderFilterItem()
              )}
            </FilterContainer>
          </CSSTransition>
          <CSSTransition
            classNames={'dc-filter-overlay'}
            timeout={this.animationDuration}
            in={this.state.containerOpened}
          >
            <FilterOverlay className={'dc-filter-overlay'} />
          </CSSTransition>
        </Portal>
      </>
    );
  }
}

FiltersContainerTabletMobile.displayName = 'FiltersContainerTabletMobile';

FiltersContainerTabletMobile.propTypes = {
  numberOfActiveFilters: PropTypes.number.isRequired,
  pendingProductsRequest: PropTypes.bool,
  isLocationSearchEnabled: PropTypes.bool,
  filtersFromSearchLabs: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      values: PropTypes.arrayOf(
        PropTypes.shape({
          value: PropTypes.string.isRequired,
          label: PropTypes.string.isRequired,
          selected: PropTypes.bool.isRequired,
          count: PropTypes.string
        })
      ).isRequired
    })
  )
};

FiltersContainerTabletMobile.defaultProps = {
  pendingProductsRequest: false,
  isLocationSearchEnabled: false,
  filtersFromSearchLabs: undefined
};

const mapStateToProps = (state) => ({
  numberOfActiveFilters: getNumberOfActiveFiltersOnActiveListingPage(state),
  filtersFromSearchLabs: getActiveListingPage(state).filtersFromSearchLabs,
  pendingProductsRequest: state.listingPage.commonData.xhrStatus.pendingProductsRequest,
  isLocationSearchEnabled:
    UISettings.get('component.mcd.postcodechecker.enabled_for_this_segment') !== false &&
    UISettings.get('component.mcd.postcodechecker.enabled') !== false
});

export default connect(mapStateToProps)(FiltersContainerTabletMobile);
